import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {filter, take, takeUntil} from 'rxjs/operators';
import {NavigationCancelService} from '../services/navigation-cancel.service';
import {SKIP_CANCEL_ON_NAV} from '../providers/http-context-tokens';

@Injectable()
export class NavigationCancelHttpInterceptor implements HttpInterceptor {
  constructor(private readonly navigationCancelService: NavigationCancelService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.get(SKIP_CANCEL_ON_NAV)) {
      return next.handle(req);
    }

    if (req.method !== 'GET' && req.method !== 'HEAD') {
      return next.handle(req);
    }

    if (!req.url.includes('/api')) {
      return next.handle(req);
    }

    if (req.url.includes('/api/token/refresh')) {
      return next.handle(req);
    }

    const requestEpoch = this.navigationCancelService.getCurrentEpoch();
    return next.handle(req).pipe(
      takeUntil(
        this.navigationCancelService.cancel$.pipe(
          filter((cancelEpoch) => cancelEpoch > requestEpoch),
          take(1)
        )
      )
    );
  }
}
